import React, {
    ReactNode,
    createContext,
    use,
    useContext,
    useEffect,
    useState,
} from 'react';
import {
    AddressType,
    BillingInfo,
    BusinessInfo,
    BusinessType,
    ContactInfo,
    ContactType,
    Facility,
    FormData,
    ShippingInfo,
    contactTypes,
} from './types';

interface FormContextType {
    formData: FormData;
    activeTab: string;
    setFormData: React.Dispatch<React.SetStateAction<FormData>>;
    setActiveTab: React.Dispatch<React.SetStateAction<string>>;
    saveFormData: (tab: string, value: any) => void;
}
export const initialFormData = {
    businessInfo: {
        facilityName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        businessType: {} as BusinessType,
        otherBusinessType: '',
        isCorporate: false,
    } as BusinessInfo,
    facilities: [],
    shippingInfo: {
        address: '',
        city: '',
        state: '',
        zip: '',
        sameAsBusiness: false,
        deliveryOption: { id: 0, name: '' },
        deliveryOptionOther: '',
        contact: {
            firstName: '',
            lastName: '',
            phone: '',
            ext: '',
            email: '',
            preferredMethod: 'phone',
            contactType: contactTypes.Shipping.type,
            sameAsPrimary: false,
        } as ContactType,
    } as ShippingInfo,

    billingInfo: {
        sameAsShipping: false,
        address: '',
        city: '',
        state: '',
        zip: '',
        contact: {
            firstName: '',
            lastName: '',
            phone: '',
            ext: '',
            email: '',
            preferredMethod: 'phone',
            contactType: contactTypes.Billing.type,
            sameAsPrimary: false,
        } as ContactType,
        isTaxExempt: false,
    } as BillingInfo,

    contactInfo: {
        contacts: [
            {
                firstName: '',
                lastName: '',
                phone: '',
                ext: '',
                email: '',
                preferredMethod: 'phone',
                contactType: contactTypes.Primary.type,
                sameAsPrimary: false,
            },
            {
                firstName: '',
                lastName: '',
                phone: '',
                ext: '',
                email: '',
                preferredMethod: 'phone',
                contactType: contactTypes.Purchasing.type,
                sameAsPrimary: false,
            },
            {
                firstName: '',
                lastName: '',
                phone: '',
                ext: '',
                email: '',
                preferredMethod: 'phone',
                contactType: contactTypes.AccountsPayable.type,
                sameAsPrimary: false,
            },
        ] as ContactType[],
    } as ContactInfo,
};
const FormContext = createContext<FormContextType | undefined>(undefined);

export const FormProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {

    const [formData, setFormData] = useState<FormData>(initialFormData);
    const [activeTab, setActiveTab] = useState<string>('business-info');

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    const saveFormData = <K extends keyof FormData>(tab: K, value: FormData[K]) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [tab]: value,
        }));
    };

    return (
        <FormContext.Provider
            value={{ formData, activeTab, setFormData, setActiveTab, saveFormData }}
        >
            {children}
        </FormContext.Provider>
    );
};

export const useFormContext = (): FormContextType => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error('useFormContext must be used within a FormProvider');
    }
    return context;
};
